import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import { memo, ReactNode } from 'react';
import { addEvent } from '@/modules/api';
import { useTheme } from '@/modules/common';
import { EventType } from '@/modules/models';
import { bridgeAtom, sessionAtom, useValue } from '@/store';
import { Button, Icon } from './PromptButton.styles';

interface PromptButtonProps {
  children?: ReactNode;
  icon?: string;
  iconSvg?: string;
  prompt: string;
  disabled?: boolean;
  onClick?: () => void;
}

export const PromptButton = memo<PromptButtonProps>(({ children, icon, prompt, disabled, iconSvg, onClick }) => {
  const { isRtl } = useTheme();
  const { pageType } = useValue(bridgeAtom);

  const session = useValue(sessionAtom);
  const defaultOnClickHandler = () => {
    window.sayWhattChat.sendNewMessage(prompt);

    addEvent({
      type: EventType.CLICKED_PROMPT_BUTTON,
      userSession: session,
      metadata: {
        pageType,
        prompt,
      },
    });
  };

  return (
    <Button disabled={disabled} onClick={onClick || defaultOnClickHandler} data-testid="saywhatt-chat-prompt">
      {icon && <Icon isRtl={isRtl} src={icon} alt={children?.toString()} />}
      {iconSvg && parse(iconSvg)}
      <span>{parse(DOMPurify.sanitize(String(children), { USE_PROFILES: { html: true } }))}</span>
    </Button>
  );
});
